"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateCampaignBidsBodySchema = exports.UpdateRegionKeywordBidSchema = exports.UpdateCampaignKeywordBidSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
exports.UpdateCampaignKeywordBidSchema = (0, core_1.StrictObject)({
    id: typebox_1.Type.Optional(core_1.IdSchema),
    text: typebox_1.Type.Optional(ruby_1.KeywordSchema),
    bid: typebox_1.Type.Optional(core_1.MoneySchema),
    status: typebox_1.Type.Optional(ruby_1.AppleChannelKeywordStatusSchema),
});
exports.UpdateRegionKeywordBidSchema = (0, core_1.StrictObject)({
    purpose: ruby_1.PurposeSchema,
    country: core_1.CountrySchema,
    keywords: typebox_1.Type.Array(exports.UpdateCampaignKeywordBidSchema),
});
exports.UpdateCampaignBidsBodySchema = (0, core_1.StrictObject)({
    regions: typebox_1.Type.Array(exports.UpdateRegionKeywordBidSchema),
});
